(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-b2b"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('atelier-hero-media')) {
    class AtelierHeroMedia extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;

        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.viewportQuery = window.matchMedia('(max-width: 749px)');
        this.syncPlayback = () => this.updatePlayback();

        this.motionQuery.addEventListener('change', this.syncPlayback);
        this.viewportQuery.addEventListener('change', this.syncPlayback);
        document.addEventListener('visibilitychange', this.syncPlayback);
        this.video.muted = true;
        this.updatePlayback();
      }

      disconnectedCallback() {
        if (!this.syncPlayback) return;
        this.motionQuery.removeEventListener('change', this.syncPlayback);
        this.viewportQuery.removeEventListener('change', this.syncPlayback);
        document.removeEventListener('visibilitychange', this.syncPlayback);
      }

      updatePlayback() {
        const isMobileMedia = this.hasAttribute('data-mobile-media');
        const hasMobileAlternative = this.hasAttribute('data-has-mobile');
        const mobileViewport = this.viewportQuery.matches;
        const activeForViewport = isMobileMedia ? mobileViewport : !hasMobileAlternative || !mobileViewport;

        if (this.motionQuery.matches || !activeForViewport || document.hidden) {
          this.video.pause();
          return;
        }

        this.video.play().catch(() => {});
      }
    }

    customElements.define('atelier-hero-media', AtelierHeroMedia);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["request-quote-form"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('submit', function (event) {
    var form = event.target;

    if (!form.classList || !form.classList.contains('b2b-form')) {
      return;
    }

    var honeypot = form.querySelector('input[name="website"]');

    if (honeypot && honeypot.value.trim() !== '') {
      event.preventDefault();
      return;
    }

    if (!form.checkValidity()) {
      event.preventDefault();
      form.reportValidity();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
